import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AvansPostItem from './AvansPostItem'
import { fetchPosts, editPost } from "../../actions/postActions"
import { fetchOrders } from '../../actions/orderActions'
import isEmpty from 'lodash/isEmpty'
import { fnum } from '../../utils/utils'
import moment from 'moment'
import Select from 'react-select'

class AvansForm extends React.Component {

  state = {
    date: moment().format('L, время HH:mm'),
    srvc_filter: ''
  }

  orderId = this.context.router.location.query.order_id;

  componentWillMount(){
    this.props.fetchPosts(this.orderId);
    this.props.fetchOrders();
    const orders = this.props.orders;
    if(orders.length){
      this.order = orders.find(el => {return el.order_id === parseInt(this.orderId,10)});
      if(this.order){
        this.setState({order: this.order});
      }
    }
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({
        date: moment().format('L, время HH:mm')
      });
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentWillReceiveProps(nextProps){
    if(this.props!==nextProps){
      const orders = nextProps.orders;
      if(orders.length){
        this.order = orders.find(el => {return el.order_id === parseInt(this.orderId,10)});
        if(this.order){
          this.setState({order: this.order});
        }
      }
    }
  }

  backToOrder = e => {
    e.preventDefault();
    this.context.router.goBack();
  }

  handleFilter = (e) => {
    this.setState({
      srvc_filter: e
    });
  }

  getSrvcOptions = () => {
    const options = [];
    const { srvcs } = this.props;
    for (let id in srvcs) {
      if (
        srvcs.hasOwnProperty(id) &&
        srvcs[id].srvc_type === -1 &&
        srvcs[id].srvc_active === 1
      ) {
        options.push({
          value: "" + srvcs[id].srvc_id,
          label: "" + srvcs[id].srvc_desc
        });
      }
    };
    return options;
  }

  render() {
    if(isEmpty(this.props.comps)
      || isEmpty(this.props.orders)
      || !this.props.posts[this.order.order_id]
    ){
      return(<div>Не загружены данные</div>);
    }
    if(this.props.comprights.indexOf(this.order.order_comp1_id) === -1){
      return(<div>Нет доступа</div>);
    }
    if(!this.state.order){
      return (
        <div>Заказ не найден</div>
      );
    }
    const { user, comps, srvcs, editPost } = this.props;
    const { order, date } = this.state;
    const srvc_filter = this.state.srvc_filter || this.props.srvc_filter || '';
    const data = this.props.posts[this.order.order_id];

    const activeData = data.filter(el => {
      if(
        el.post_active === 1 &&
        el.post_payed === 0 &&
        el.post_payer === order.order_comp1_id &&
        (el.post_price*el.post_qntt !== 0 || srvcs[el.post_srvc_id].srvc_type === 1) &&
        (
          srvc_filter.split(',').indexOf(""+el.post_srvc_id) !== -1 ||
          srvcs[el.post_srvc_id].srvc_type === 1
        )
      ){
        return true;
      }
      return false;
    });

    const sortD = activeData.sort( (a, b) => {
      if(srvcs[a.post_srvc_id].srvc_type < srvcs[b.post_srvc_id].srvc_type)
        return -1
      if(srvcs[a.post_srvc_id].srvc_type > srvcs[b.post_srvc_id].srvc_type)
        return 1
      if(a.post_desc < b.post_desc)
        return -1
      if(a.post_desc > b.post_desc)
        return 1
      if(a.post_id < b.post_id)
        return -1
      if(a.post_id > b.post_id)
        return 1
      return 0
    });

    var dataAvans = {};
    var sumAvans = 0;
    for(var i = 0; i < sortD.length ; i++){
      if(srvcs[sortD[i].post_srvc_id].srvc_type === -1){
        if (dataAvans[sortD[i].post_link]) {
          dataAvans[sortD[i].post_link].data.push(sortD[i]);
        }
        else {
          dataAvans[sortD[i].post_link] = {data: [sortD[i]]};
        }
        if(sortD[i].post_avans === 1){
          sumAvans += sortD[i].post_price*sortD[i].post_qntt;
        }
      }
      else {
        if (dataAvans[sortD[i].post_id]) {
          dataAvans[sortD[i].post_id].cost = sortD[i];
        }
      }
    }

    let lineNum = 1;
    const mappedAvans = [];
    for (let costId in dataAvans) {
      if (dataAvans.hasOwnProperty(costId)) {
        for (let i = 0; i < dataAvans[costId].data.length; i++) {
          const post = {
            ...dataAvans[costId].data[i],
            cost_desc: (
              dataAvans[costId].cost ?
              ` (${dataAvans[costId].cost.post_desc})` : ''
            )
          }
          const num = post.post_avans ? ("" + (lineNum++)) : "";
          mappedAvans.push(
            <AvansPostItem
              key={post.post_id}
              num={num}
              data={post}
              editPost={editPost}
            />
          );
        }
      }
    }

    return (
      <div className="toPrint">
        <div className="form-group form-inline hidden-print">
          <button className="btn btn-default"
            onClick={this.backToOrder}>
            Назад
          </button>{" "}
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={this.getSrvcOptions()}
              multi
              simpleValue
              value={srvc_filter}
              onChange={this.handleFilter}
              placeholder="Метод оплат"
            />
          </div>
        </div>
        <table className="table borderless">
          <tbody>
            <tr>
              <td>Компания</td>
              <td><b>{comps[order.order_comp_id].comp_desc}</b></td>
              <td>Мероприятие</td>
              <td><b>{order.order_desc}</b></td>
            </tr>
            <tr>
              <td>Дата проведения</td>
              <td><b>{moment(order.order_edate).format('L')}</b></td>
              <td>Подотчетное лицо</td>
              <td><b>{user.user_fname+" "+user.user_lname}</b></td>
            </tr>
          </tbody>
        </table>
        <h3 className="text-center">Авансовый отчет от {date}</h3>
        <table className="table table-striped table-hover bottom-buffer2">
          <thead>
            <tr>
              <th className="hidden-print">Печ.</th>
              <th>№</th>
              <th className="col-xs-6">Наименование</th>
              <th className="col-xs-1 text-right"><b>План</b>,<br />руб.</th>
              <th className="col-xs-1 text-right"><b>Факт</b>,<br />руб.</th>
              <th className="col-xs-4">Примечание</th>
            </tr>
          </thead>
          <tbody>
            {mappedAvans}
          </tbody>
          <tfoot>
            <tr>
              <th className="hidden-print"></th>
              <th></th>
              <th><b>Итого</b></th>
              <th className="text-right">{fnum(sumAvans)}</th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
        <div className="row">
          <div className="col-xs-2"><b>Получил(а)</b></div>
          <div className="col-xs-3 borderBottom"></div>
          <div></div>
        </div>
        <div className="row bottom-buffer2">
          <div className="col-xs-2"></div>
          <div className="col-xs-3 text-center" style={{borderTop:"1px solid black"}}>сумма</div>
          <div className="col-xs-3 text-center" style={{borderTop:"1px solid black"}}>подпись</div>
        </div>
        <div className="row">
          <div className="col-xs-2"><b>Остаток</b></div>
          <div className="col-xs-3"></div>
          <div></div>
        </div>
        <div className="row">
          <div className="col-xs-2"></div>
          <div className="col-xs-3 text-center" style={{borderTop:"1px solid black"}}>сумма</div>
          <div className="col-xs-3 text-center" style={{borderTop:"1px solid black"}}>подпись</div>
        </div>
      </div>
    )

  }
}

AvansForm.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapPostsToProps(store) {
  return {
    orders: store.orders.data,
    comprights: store.auth.comprights,
    posts: store.posts,
    comps: store.comps.data,
    user: store.auth.user,
    srvcs: store.srvcs.data,
    srvc_filter: store.settings.default_avans_srvc_type
  }
}

export default connect(mapPostsToProps, { fetchPosts, fetchOrders, editPost })(AvansForm);



// WEBPACK FOOTER //
// ./src/components/avans/AvansForm.js